import { Radio, RadioGroup } from 'react-aria-components';
import { FieldErrorText, FieldHint, FieldLabel, fieldClassName, joinClasses, rowClass } from './Field';

export interface RadioOption {
  key: string;
  label: string;
}

export interface RadioGroupFieldProps {
  label: string;
  hint?: string;
  error?: string;
  options: RadioOption[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}

/** A ring with an inner dot: selected reads as "chosen", not as a filled bullet.
 *  Render inside a react-aria `Radio` that carries the `group` class. */
export function RadioMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={joinClasses(
        'flex shrink-0 items-center justify-center w-4 h-4 m-0 p-0 border border-line-strong rounded-pill bg-surface group-data-[selected]:border-ink group-data-[selected]:border-[1.5px] group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-offset-2 group-data-[focus-visible]:outline-ink',
        className
      )}
    >
      <span className="block w-2 h-2 m-0 p-0 rounded-pill bg-transparent group-data-[selected]:bg-ink" />
    </span>
  );
}

export function RadioGroupField({ label, hint, error, options, value, onChange, className }: RadioGroupFieldProps) {
  return (
    <RadioGroup value={value} onChange={onChange} isInvalid={!!error} className={fieldClassName(className)}>
      <FieldLabel>{label}</FieldLabel>
      {options.map((o) => (
        <Radio
          key={o.key}
          value={o.key}
          className={joinClasses('group', rowClass)}
        >
          <RadioMark />
          {o.label}
        </Radio>
      ))}
      <FieldHint hint={hint} />
      <FieldErrorText error={error} />
    </RadioGroup>
  );
}
